import { SearchIcon } from 'lucide-react'
import { useTranslations } from 'next-intl'
import Spinner from '../Spinner/Spinner'
import * as styles from './Input.css'

type InputProps = React.HTMLProps<HTMLInputElement> & {
  rootProps?: React.HTMLProps<HTMLDivElement>
  inputProps?: React.HTMLProps<HTMLInputElement>
  icon?: boolean
  endWidget?: React.ReactNode
  isPending?: boolean
}
export default function Input({
  style,
  placeholder,
  icon = true,
  rootProps = {},
  inputProps = {},
  endWidget,
  isPending = false,
  ref,
  ..._inputProps
}: InputProps) {
  const t = useTranslations('Input')
  return (
    <div
      {...rootProps}
      className={`${styles.root} ${rootProps?.className ?? ''}`}
      style={style}
      aria-disabled={inputProps.disabled}
    >
      {icon && !isPending && <SearchIcon size={20} className={styles.icon} />}
      {icon && isPending && <Spinner size={20} className={styles.icon} />}
      <input
        {..._inputProps}
        {...inputProps}
        ref={ref}
        className={`${styles.input} ${inputProps.className ?? ''}`}
        placeholder={placeholder ?? t('searchLawPlaceholder')}
        style={{ paddingLeft: icon ? 47 : 15 }}
      />
      {endWidget}
    </div>
  )
}
